"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  flightSearchCard: {
    paddingTop: '36px !important',
    paddingRight: '30px !important',
    paddingLeft: '30px !important'
  },
  cardContent: {
    [_theme.default.breakpoints.up('xs')]: {
      padding: '30px 20px 30px 20px !important'
    },
    [_theme.default.breakpoints.up('sm')]: {
      padding: '33px 20px 30px 20px !important'
    },
    [_theme.default.breakpoints.up('md')]: {
      padding: '33px 20px 30px 20px !important'
    },
    [_theme.default.breakpoints.up('lg')]: {
      padding: '33px 30px 30px 20px !important'
    }
  },
  cardActions: {
    [_theme.default.breakpoints.up('xs')]: {
      padding: '15px 20px 15px 20px !important'
    },
    [_theme.default.breakpoints.up('sm')]: {
      padding: '20px 20px 20px 20px !important'
    },
    [_theme.default.breakpoints.up('md')]: {
      padding: '20px 20px 20px 20px !important'
    },
    [_theme.default.breakpoints.up('lg')]: {
      padding: '15px 30px 15px 30px !important'
    }
  },
  gridItem: {
    [_theme.default.breakpoints.up('xs')]: {
      padding: '17px 10px 17px 10px !important'
    },
    [_theme.default.breakpoints.up('sm')]: {
      padding: '17px 10px 17px 10px !important'
    },
    [_theme.default.breakpoints.up('md')]: {
      padding: '20px 10px 20px 10px !important'
    },
    [_theme.default.breakpoints.up('lg')]: {
      padding: '20px 15px 20px 15px !important'
    }
  },
  gridItemCalendar: {
    [_theme.default.breakpoints.up('md')]: {
      padding: '20px 10px 20px 10px !important'
    },
    [_theme.default.breakpoints.up('lg')]: {
      padding: '20px 15px 20px 15px !important'
    }
  }
});
var _default = exports.default = useStyles;